// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SpectacularPortrait-module__container___vdWDg {
    position: relative;
    display: inline-block;
    height: 510px;
    width: auto;
    aspect-ratio: 301/510;

    transform: perspective(2000px);
    transition: all 0.3s ease;
    /* Add depth to the whole panel */
    box-shadow: 
        -20px 20px 30px rgba(0, 0, 0, 0.2),
        -5px 5px 15px rgba(0, 0, 0, 0.1),
        inset 2px -2px 5px rgba(255, 255, 255, 0.2);
}

.SpectacularPortrait-module__backgroundImage___lNFsY {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: contain;

    background: linear-gradient(
        105deg,
        rgba(255, 255, 255, 0.2) 0%,
        rgba(255, 255, 255, 0) 40%
    );
}

.SpectacularPortrait-module__overlayImage___KEAca,
.SpectacularPortrait-module__overlayVideo___GBLna {
    position: absolute;
    top: 3.5%;
    left: 6.5%;
    width: 87.1%;
    height: 93%;
    object-fit: cover;
}

@media (max-width: 768px) {
    .SpectacularPortrait-module__container___vdWDg {
        height: 400px;
    }
}`, "",{"version":3,"sources":["webpack://./app/components/ProofOfDeliveryLayout/Panels/SpectacularPortrait/SpectacularPortrait.module.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,aAAa;IACb,WAAW;IACX,qBAAqB;;IAErB,8BAA8B;IAC9B,yBAAyB;IACzB,iCAAiC;IACjC;;;mDAG+C;AACnD;;AAEA;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,mBAAmB;;IAEnB;;;;KAIC;AACL;;AAEA;;IAEI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,YAAY;IACZ,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI;QACI,aAAa;IACjB;AACJ","sourcesContent":[".container {\n    position: relative;\n    display: inline-block;\n    height: 510px;\n    width: auto;\n    aspect-ratio: 301/510;\n\n    transform: perspective(2000px);\n    transition: all 0.3s ease;\n    /* Add depth to the whole panel */\n    box-shadow: \n        -20px 20px 30px rgba(0, 0, 0, 0.2),\n        -5px 5px 15px rgba(0, 0, 0, 0.1),\n        inset 2px -2px 5px rgba(255, 255, 255, 0.2);\n}\n\n.backgroundImage {\n    display: block;\n    width: 100%;\n    height: 100%;\n    object-fit: contain;\n\n    background: linear-gradient(\n        105deg,\n        rgba(255, 255, 255, 0.2) 0%,\n        rgba(255, 255, 255, 0) 40%\n    );\n}\n\n.overlayImage,\n.overlayVideo {\n    position: absolute;\n    top: 3.5%;\n    left: 6.5%;\n    width: 87.1%;\n    height: 93%;\n    object-fit: cover;\n}\n\n@media (max-width: 768px) {\n    .container {\n        height: 400px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `SpectacularPortrait-module__container___vdWDg`,
	"backgroundImage": `SpectacularPortrait-module__backgroundImage___lNFsY`,
	"overlayImage": `SpectacularPortrait-module__overlayImage___KEAca`,
	"overlayVideo": `SpectacularPortrait-module__overlayVideo___GBLna`
};
export default ___CSS_LOADER_EXPORT___;
